export const BASE_EVENTS_PATH = '/sell/events';
export const BASE_TICKETS_PATH = '/sell/tickets';
export const BASE_SELECT_TICKETS_PATH = '/sell/select-tickets';
export const BASE_UNSELECT_TICKET_PATH = '/sell/unselect-ticket';
export const BASE_SAVE_SELL_PRICE_PATH = '/sell/save-sell-price';
export const BASE_VALIDATE_TICKET_CODES_PATH = '/sell/validate-ticket-codes';
export const BASE_ADD_TICKET_CODES_PATH = '/sell/add-ticket-codes';
export const BASE_BANK_ACCOUNT_PATH = '/sell/bank-account';
export const BASE_SAVE_BANK_ACCOUNT_PATH = '/sell/bank-account/save';
export const BASE_PUBLISH_TICKETS_PATH = '/sell/publish';

export const BASE_API_CHECK_USER_BY_EMAIL = '/check-user-by-email';
export const BASE_API_GET_USERNAME = '/username';
export const BASE_API_LOGIN = '/login';
export const BASE_API_REGISTER = '/register';
export const BASE_API_SOCIAL_CONNECT = '/connect';
export const BASE_API_FORGOT_PASSWORD = '/forgot-password';
export const BASE_API_PROVIDER = '/provider';
export const CONNECT_IABILET = 'iabilet';
